<script setup>
import {computed, onUnmounted, getCurrentInstance, set, del} from 'vue'

const {proxy} = getCurrentInstance()
const store = proxy.$store
const route = proxy.$route

// --- Computed ---
const formData = computed(() => store.state.odpReports.formData)
const schools = computed(() => store.state.odpReports.schools)

// --- Created Logic ---
const schoolId = route.query.schoolId || ''
set(formData.value, 'schoolId', schoolId)

// --- Destroyed Logic ---
onUnmounted(() => {
    del(formData.value, 'schoolId')
})
</script>

<template>
    <select
        required
        v-model="formData.schoolId"
        class="form-select form-select-sm"
        name="school"
        oninvalid="this.setCustomValidity('Please select a school')"
        oninput="this.setCustomValidity('')"
    >
        <option value="">Select&hellip;</option>
        <template v-if="schools">
            <option v-for="school in schools" :key="school.id" :value="school.id">
                {{ school.name }}
            </option>
        </template>
    </select>
</template>